import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import Skeleton from '@material-ui/lab/Skeleton';
import Pagination from '../../pagination/pagination.component';
//styles and icons 
import { Paper } from '@material-ui/core';
import { Row, Col } from 'react-bootstrap';
import activityIcon from '../../../images/activity.svg';


// this component represent the profile activities part in explore opportunities page 
class Activities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            choosenSpecialities: []
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {
            //handle fetch specialities and tags dropdown   
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            const id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `
                    query($user_id : Int){
                      user(id: $user_id){
                        id
                     Activities {
                      message
                      created_at
                    }
                      }
                    }
       `, variables: { user_id: id }
            }).then(res => {
                    this.setState({ ...this.state, userData: res.data.user });
            });
        }
    }
    componentWillMount() {
        this.getUserData()
    }
    render() {
        if (!this.state.userData) {
            return (
                <div className="">
                    <Skeleton animation="wave" width={170} height={40}/>
                    <Skeleton  className="mb-2" variant="rect" animation="wave"  height={160}/>
                </div>
            )
        } else {
            return (
                <div className="activity">
                    <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                        <Row >
                            <Col md={12}>
                                <Row className="m-0 mb-3 align-items-center">
                                    <Col className="text-left p-0">
                                        <h6 className="bold mb-0">My Activity</h6>
                                    </Col>
                                </Row>
                                <Row className="m-0">
                                    <Col className="p-0">
                                        {(this.state.userData) ?
                                            this.state.userData.Activities.map(activity =>
                                                <div className="mb-3 border-bottom  "> 
                                                    <p className="mb-1">
                                                        <span className="pr-2"><img src={activityIcon} alt="activity"/></span>
                                                        {activity.message}
                                                    </p>
                                                    <div className="mb-2">
                                                        <small className="text-grey"> {activity.created_at}</small>
                                                    </div>
                                                </div>): ''}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Paper>
                </div>
            )
        }
    }
}


export default withRouter(Activities)
